export const hasDeliverableParticipantEmail = (email) => !!String(email ?? '').trim();
export const hasDeliverableParticipantMobile = (mobile) => !!String(mobile ?? '').trim();
/**
 * Normalize a catalog channel into email | sms | push | other.
 * Checks type, name, and label because list payloads sometimes only surface a label.
 */
export const getChannelKind = (channel) => {
    const t = (channel.type || channel.name || channel.label || '').toLowerCase();
    if (t.includes('email')) {
        return 'email';
    }
    if (t.includes('sms') || t.includes('text')) {
        return 'sms';
    }
    if (t.includes('push') || t.includes('apn') || t.includes('fcm')) {
        return 'push';
    }
    return 'other';
};
export const isChannelDeliverable = (channel, capabilities) => {
    // Axon send requires a linked account for all channel kinds.
    if (!capabilities.hasAccount) {
        return false;
    }
    const kind = getChannelKind(channel);
    if (kind === 'email') {
        return capabilities.hasEmail;
    }
    if (kind === 'sms') {
        return capabilities.hasMobile;
    }
    if (kind === 'push') {
        return true;
    }
    // Unknown kinds: defer to the backend rather than hard-blocking submit.
    return true;
};
export const planTemplateDelivery = (template, capabilities) => {
    const channels = template?.channels ?? [];
    const deliverable = channels.filter((channel) => isChannelDeliverable(channel, capabilities));
    const skipped = channels.filter((channel) => !isChannelDeliverable(channel, capabilities));
    return {
        deliverable,
        skipped,
        canSend: deliverable.length > 0,
        isPartial: deliverable.length > 0 && skipped.length > 0,
    };
};
export const channelDisplayName = (channel) => channel.label || channel.type || channel.name || '';
